import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HeaderService } from './header/header.service';

import {
    DEFAULT_ENTERPRISE_DISPLAY_NAME,
    getConnectedEnterpriseNameFromLocalStorage,
    getConnectedEnterpriseNameFromUser,
    resolveEnterpriseDisplayName,
} from './enterprise-context';

@Injectable({ providedIn: 'root' })
export class EnterpriseBrandingService {
    private readonly _name$ = new BehaviorSubject<string>(
        getConnectedEnterpriseNameFromLocalStorage() || DEFAULT_ENTERPRISE_DISPLAY_NAME
    );

    readonly name$ = this._name$.asObservable();

    constructor(private headerService: HeaderService) {}

    getName(): string {
        return this._name$.getValue();
    }

    setName(name?: string | null): void {
        const resolved = resolveEnterpriseDisplayName(name);
        this._name$.next(resolved);
        this.headerService.refreshBrowserTabFromCurrentConfig();
    }

    syncFromUser(user: unknown): void {
        this.setName(getConnectedEnterpriseNameFromUser(user));
    }

    syncFromLocalStorage(): void {
        this.setName(getConnectedEnterpriseNameFromLocalStorage());
    }
}
